import React from 'react'
import RoleList from '../../features/admin/RoleList'
const RoleListPage = () => {
  return <RoleList />
}

export default RoleListPage